module.exports = __webpack_public_path__ + "static/images/bulk-upload-nudge.2TS1xha.svg";